import { CartProvider } from "./CartContext";
import { iProviderProps } from "./types";
import { UserProvider } from "./UserContext";

export const Providers = ({ children }: iProviderProps) => {
  return (
    <UserProvider>
      <CartProvider>{children}</CartProvider>
    </UserProvider>
  );
};
